import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon",
  style: {"width":"1em","height":"1em","vertical-align":"middle","fill":"currentColor","overflow":"hidden"},
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M512 682.667c-204.8 0-369.778 62.577-369.778 142.222S307.2 967.11 512 967.11s369.778-62.578 369.778-142.222S716.8 682.667 512 682.667m0 199.11c-142.222 0-256-25.6-256-56.888S369.778 768 512 768s256 25.6 256 56.889-113.778 56.889-256 56.889" }, null, -1),
    _createElementVNode("path", { d: "M512 56.889c-142.222 0-256 113.778-256 256s256 540.444 256 540.444S768 455.111 768 312.89s-113.778-256-256-256m0 369.778c-62.578 0-113.778-51.2-113.778-113.778S449.422 199.11 512 199.11s113.778 51.2 113.778 113.778S574.578 426.667 512 426.667" }, null, -1)
  ])))
}
export default { render: render }